module.exports = __webpack_public_path__ + "roles-icon.png?e295d92c63a2ed61d2012fc3ba2dd5eb";